import api from "./client";

export const fetchDashboardSites = async () => {
  const { data } = await api.get("/dashboard/sites");
  return data;
};
